import MainLayout from '../layouts/main';
import Home from './home';

function HomePage() {
  return (
    <MainLayout loginRequired={false} studentRequired={false} title={HOME_PAGE_TITLE}>
      <Home />
    </MainLayout>
  );
}

export const HOME_PAGE_TITLE = 'سامانه آزمون های مدمشاور';

export default HomePage;
